module.exports = __webpack_public_path__ + "static/img/banner.a9e1408.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/solutions/artificialintelligence/banner.png
// module id = FO16
// module chunks = 12